import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const HomePage = () => import("../views/HomePage");

const router = new VueRouter({
  // mode: 'history',
  // base: __dirname,
  routes: [
    {
      path: "/",
      component: HomePage
    },
    {
      path: "/introduce",
      component: () => import("../views/HomePage1")
    },
    {
      path: "/link",
      component: () => import("../views/lianxiwomeng")
    },
    {
      path: "/privacy",
      component: () => import("../views/yingsi")
    },
    {
      path: "/product",
      component: () => import("../views/product")
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js